/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=e660fd40"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Develop\\Workspaces\\WeApp\\blockchain_ait_h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__